<template>
  <div class="message-customer">
    <!-- <el-tooltip class="item" effect="dark" content="咨询技术人员：18682476350" placement="left">
      <div class="circle" @click="handleShow">
        <svg-icon class-name="message" name="message"></svg-icon>
      </div>
    </el-tooltip>
    <el-popover placement="left-end" width="214px" trigger="hover">
      <div class="popover-wrapper">
        <p class="title">添加专属技术人员</p>
        <div class="tip">为您提供专属1v1服务</div>
        <img src="@/assets/img/weixin.jpg" alt="" class="qr-code" />
        <div class="scan-code-add">立即微信扫码添加</div>
        <div class="online-time">在线时间：全天</div>
      </div>
      <template #reference>
        <div class="circle">
          <svg-icon class-name="customer-service" name="customer-service"></svg-icon>
        </div>
      </template>
    </el-popover> -->
  </div>
</template>

<script lang="ts">
export default {
  name: 'AffixMessageCustomer'
}
</script>

<script lang="ts" setup></script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';
.message-customer {
  position: absolute;
  right: 6px;
  bottom: 140px;
  .circle {
    width: 40px;
    height: 40px;
    background: #ffffff;
    box-shadow: 0px 8px 11px 0px rgba(18, 23, 29, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 12px;
    &:hover {
      .message,
      .customer-service {
        color: $color-primary;
      }
    }
    .message {
      width: 21px;
      height: 20px;
    }
    .customer-service {
      width: 22px;
      height: 23px;
    }
  }
}
.popover-wrapper {
  padding: 10px;
  text-align: center;
  .title {
    height: 20px;
    font-weight: 600;
    line-height: 20px;
    color: #333;
  }
  .tip {
    margin: 7px 0 16px;
    font-size: 12px;
    color: $color-text-tip;
    line-height: 17px;
  }
  .qr-code {
    width: 129px;
    height: 129px;
  }
  .scan-code-add {
    height: 20px;
    line-height: 20px;
    margin: 10px 0 6px;
    color: #333;
  }
  .online-time {
    height: 17px;
    font-size: 12px;
    color: $color-text-tip;
    line-height: 17px;
  }
}
</style>
